const { WUR_REPORTER_INTERIM_ACTIONS, WUR_REPORTER_INTERIM_ACTIONS_WITHOUT_YEAR } = require('./constants');

const wurReporterInterimPermissions = (
  action,
  permissions,
  year,
) => {
  if (
    action.startsWith('wurReporterInterim:') &&
    permissions.some((item) =>
      ['DATAPOINTS_DEVELOPER', 'THE_STAFF_ACCESS_ALL_INSTITUTIONS'].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    WUR_REPORTER_INTERIM_ACTIONS.some((wurAction) =>
      action.includes(wurAction),
    ) &&
    permissions.includes(`WUR_REPORTER_INTERIM_${year}`)
  ) {
    return true;
  }

  if (
    WUR_REPORTER_INTERIM_ACTIONS_WITHOUT_YEAR.some((exploreAction) => action === exploreAction) &&
    permissions.some((item) =>
      item.includes('WUR_REPORTER_INTERIM')
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  wurReporterInterimPermissions,
};
